import { render } from "./ReportLocationsIndex.vue?vue&type=template&id=a56a6d46&scoped=true"
import script from "./ReportLocationsIndex.vue?vue&type=script&lang=js"
export * from "./ReportLocationsIndex.vue?vue&type=script&lang=js"

import "./ReportLocationsIndex.vue?vue&type=style&index=0&id=a56a6d46&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a56a6d46"]])

export default __exports__